<template>
  <template v-if="offerSelected >= 0">
    <div class="totalbox" v-if="offerSelected >= 0 && respond_id > 0 && notEmpty(flightSummary)">
      <div class="titbox">Flight Information</div>
      <div class="listbox" v-for="(item, idx) in flightSummary">
        <div class="tit">{{ (idx) ? 'Return' : 'Depart' }}</div>
        <div class="row">
          <p class="label">
            <img :src="'https://data.triptogo.com/image/flight/logos/' + item.logo + '.png'" class="airico" alt="">
          </p>
          <p class="contxt route-block">
            <span class="route-title">
              {{ item?.depart?.city??'' }} ({{ item?.depart?.airport??'' }}) - {{ item?.arrival?.city??'' }} ({{
                item?.arrival?.airport??'' }})
            </span>
            <span v-if="getAirlineDisplay(item)" class="route-subtitle">{{ getAirlineDisplay(item) }}</span>
          </p>
        </div>
        <div class="row">
          <p class="label">Departure</p>
          <p class="contxt"> {{ item?.depart?.at ? flyWeekMDate(item.depart.at) + ' ' + onlyFtime(item.depart.at) : '' }}</p>
        </div>
        <div class="row">
          <p class="label">Arrival</p>
          <p class="contxt">{{ item?.arrival?.at ? flyWeekMDate(item.arrival.at) + ' ' + onlyFtime(item.arrival.at) : '' }}</p>
        </div>
        <div class="row">
          <p class="label">Stops</p>
          <p class="contxt stop-summary">
            <span v-if="hasOvernightWarning(item)" class="overnight-warning">
              <img src="/images/flight/icon_error.png" class="overnight-warning-icon" alt="">
              Overnight
            </span>
            <span>{{ item.seg == 1 ? 'Direct' : ((parseInt(item.seg) - 1) + ' Stop') }}</span>
          </p>
        </div>
        <div class="row">
          <p class="label">Baggage</p>
          <p class="contxt">
          <div style="text-align:right;">
            {{ item.bag > 0 ? item.bag + ' free checked luggage' : 'No checked luggage' }}
            <br>{{ getCarryOnText(item) }}
          </div>
          </p>
        </div>
      </div>

      <div class="listbox ticket-price-box" v-if="totalShow">
        <div class="row total">
          <p class="label">Ticket Price</p>
          <p class="contxt">{{ 
          priceFormat(odata.currency,(cityprice + parseFloat(flightOffer.price)) * parseInt(flightOffer.persons),',',2,1)
            }}</p>
        </div>
      </div>
      <div class="listbox flight-policy-box">
        <p class="contxt click"><span @click="airfareEvent">Click
            <img src="/images/flight/icon_tipinfo.png" class="ico" alt=""></span>
          to check the flight policy</p>
      </div>
    </div>
    <div v-else-if="offerSelected > 0 && respond_id == 0">
      <tbaSummary :flightSummary="flightSummary" :rmkey="rmkey" :odkey="odkey"  :refidx="refidx"></tbaSummary>
    </div>

    <div class="prop" v-if="airfaretips" @click="airfaretips = false">
      <div class="con airfaretipscon" @click.stop>
        <div class="closer fixed_closer" @click="airfaretips = false">
          <img src="/images/icon_close.png" />
        </div>
        
        <div class="pop_con">

        <div style="font-weight:bold;text-align:center;padding:1rem;padding-top:0px;margin-top:0px;">Operator
          Policy-Flight Portion</div>
        <p v-if="flight_deposit > 0">Your air deposit of {{ priceFormat(odata.currency, flight_deposit, ',', 2,1) }} amount.</p>
        <p>Tickets will be issued immediately upon full airfare payment.</p>

        <p v-for="(item, tidx) in displayTerms" :key="tidx">
          {{ item }}
        </p>
        <p>Once issued, any name changes may require cancellation and rebooking of a new ticket.</p>
        <p>Additional baggage charges may apply.The baggage allowance for infants and children can differ from that of
          adults, depending on the airline and destination. </p>
        <p>You will receive the flight confirmation within 24-72 hours after issued.</p>
        <p>We highly recommend that you select and pay the Protection ToGo Plan at the time of booking. </p>
      </div>
    </div>
    </div>
  </template>
  <template v-else-if=" offerSelected<0 && odata.isFlight>0 && step===1 ">
    <bookingFlySummary v-if="notEmpty(flyOffer) && istba(flightSummary)<1 " :flyOffer="flyOffer" :rmkey="rmkey" :odkey="odkey"></bookingFlySummary>
    <tbaSummary v-else :flightSummary="flightSummary" :rmkey="rmkey" :odkey="odkey"  :refidx="refidx"></tbaSummary> 
  </template>
</template>
<script>
import { scrollWindow, formatCurrency, priceAmount, notEmpty, priceFormat, productIdExt } from "@/utils/tool.js";
import Request from '@/services/Request.ts';
import tbaSummary from "@/components/tbaSummary.vue";
import bookingFlySummary from "@/components/bookingFlySummary.vue";
import { localDriver } from '@/utils/localDriver'
import { isOvernightLayover } from '@/utils/flightLayoverRules'

export default {
  components: {
    tbaSummary,
    bookingFlySummary,
  },
  props: ['step', 'refidx', 'offerSelected', 'respond_id', 'flyOffer','rmkey','odkey'],
  data() {
    return {
      priceFormat,
      pressnum: 2,
      ismobile: false,
      flightSummary: [],
      flightOffer: {},
      departcity: '',
      arrivalcity: '',
      returncity: '',
      cityprice: 0,
      airfaretips: false,
      terms: '',
      odata: { isFlight: 0 },
      flight_deposit: 0,
      persons: 0,
      memberType: 0,
    };
  },
  computed: {
    displayTerms() {
      const list = Array.isArray(this.terms) ? this.terms : []
      if (!this.shouldApplyMembershipRefundWording()) {
        return list
      }
      const depositWord = this.getMembershipDepositWord()
      if (!depositWord) {
        return list
      }
      return list.map((line) => {
        const content = String(line ?? '')
        if (!/your\s+(?:non-refundable|refundable)\s+air deposit is/i.test(content)) {
          return content
        }
        return content.replace(/(your\s+)(?:non-refundable|refundable)(\s+air deposit is)/i, `$1${depositWord}$2`)
      })
    },
  },
  watch: {
    offerSelected: {
      async handler(newValue, oldValue) {
        await this.pageDataInit();
      },
    },
    respond_id: {
      async handler(newValue, oldValue) {
        await this.pageDataInit();
      },
    },
    refidx: {
      async handler(newValue, oldValue) {
        await this.pageDataInit();
      },
    },
  },
  computed: {
    totalShow() {
      if (!this.odata || !this.odata.product_info) return false;
      return this.odata.product_info.model.toUpperCase().slice(0, 3) !== 'FP-';
    }
  },
  async mounted() {
    this.ismobile = (document.documentElement.clientWidth < 750);
    await this.pageDataInit();
  },
  methods: {
    getCarryOnText(item) {
      return item?.carry_on_text || '1 PC carry-on luggage'
    },
    hasOvernightWarning(item) {
      if (item?.overnight_layover || item?.has_overnight_layover || item?.overnightLayover) {
        return true
      }
      const segments = item?.segments
      if (!segments || segments.length < 2) return false
      for (let i = 0; i < segments.length - 1; i++) {
        const arrivalAt = segments[i]?.arrival?.at
        const departureAt = segments[i + 1]?.departure?.at
        if (!arrivalAt || !departureAt) continue
        if (isOvernightLayover(arrivalAt, departureAt).isOvernight) {
          return true
        }
      }
      return false
    },
    getAirlineDisplay(item) {
      if (typeof item?.airline_display === 'string' && item.airline_display.trim()) {
        return item.airline_display.trim()
      }
      if (Array.isArray(item?.airline_names)) {
        return item.airline_names
          .map((name) => String(name || '').trim())
          .filter((name, index, arr) => name && arr.indexOf(name) === index)
          .join(' · ')
      }
      const candidates = [
        item?.airline,
        item?.airline_name,
        item?.airlineName,
        item?.marketing_airline,
        item?.marketingAirline,
        item?.operating_airline,
        item?.operatingAirline,
      ]
      return candidates
        .map((name) => String(name || '').trim())
        .filter((name, index, arr) => name && arr.indexOf(name) === index)
        .join(' · ')
    },
    istba(flightSummary){
      for(let i in flightSummary){
         if('depart' in flightSummary[i])
         {
           return false
         }
         else{
           return true
         }
      }
    },
    async pageDataInit()
    {
        this.odata = await localDriver.getItem(this.odkey)
        const customerInfo = await localDriver.getItem('customerInfo')
        this.memberType = this.parseMemberTypeValue(
          customerInfo?.member_type
          ?? customerInfo?.memberType
          ?? customerInfo?.mmshipHistory?.[0]?.mmshiptypeid
          ?? customerInfo?.mmshipHistory?.[0]?.description
          ?? customerInfo?.mmshipHistory?.[0]?.name
          ?? customerInfo?.membership
        )
        this.flightSummary = this.odata?.flightSummary??{}
        this.flightOffer = this.odata?.flightOffer??{}
        this.cityprice = (this.odata && this.odata.product_info && this.odata.product_info.model.toUpperCase().slice(0, 3) === 'FP-') ? 0 : parseFloat(this.odata.cityprice);
    },
    parseMemberTypeValue(raw) {
      if (raw == null) return 0
      if (typeof raw === 'number' && Number.isFinite(raw)) return raw
      if (Array.isArray(raw)) {
        for (const item of raw) {
          const parsed = this.parseMemberTypeValue(item)
          if (parsed > 0) return parsed
        }
        return 0
      }
      if (typeof raw === 'object') {
        const nested = [
          raw?.membershiptype_id,
          raw?.member_type,
          raw?.type_id,
          raw?.membershipType,
          raw?.mmshiptypeid,
          raw?.name,
          raw?.title,
          raw?.label,
          raw?.text,
        ]
        for (const item of nested) {
          const parsed = this.parseMemberTypeValue(item)
          if (parsed > 0) return parsed
        }
        return 0
      }
      let text = ''
      try {
        text = String(raw).trim().toLowerCase()
      } catch (e) {
        return 0
      }
      if (!text) return 0
      if (text.includes('inside')) return 1
      if (text.includes('insider')) return 1
      if (text.includes('pathfinder')) return 10
      if (text.includes('voyager')) return 2
      if (text.includes('adventurer')) return 3
      if (text.includes('elite')) return 4
      const n = parseInt(text, 10)
      return Number.isFinite(n) ? n : 0
    },
    resolveMemberType() {
      return this.parseMemberTypeValue(this.memberType)
    },
    getMembershipDepositWord() {
      const memberType = this.resolveMemberType()
      const explicitWord = String(this.odata?.membership_refund_deposit_word ?? '').trim().toLowerCase()
      if (memberType === 1 || memberType === 10) {
        if (explicitWord === 'non-refundable' || explicitWord === 'refundable') return explicitWord
        return 'non-refundable'
      }
      if (memberType >= 2) return 'refundable'
      return ''
    },
    getMembershipRefundCandidates() {
      const o = this.odata || {}
      return [
        o?.flightOffer?.info?.refund_term,
        o?.flightOffer?.info?.refund_terms,
        o?.flightOffer?.info?.refundTerm,
        o?.flightOffer?.info?.refundTerms,
        o?.flightOffer?.info?.rule_id,
        o?.flightOffer?.info?.ruleId,
        o?.flightOffer?.refund_term,
        o?.flightOffer?.refund_terms,
        o?.flightOffer?.refundTerm,
        o?.flightOffer?.refundTerms,
        o?.flightOffer?.rule_id,
        o?.flightOffer?.ruleId,
        o?.tripFlightInfo?.refund_term,
        o?.tripFlightInfo?.refund_terms,
        o?.tripFlightInfo?.refundTerm,
        o?.tripFlightInfo?.refundTerms,
        o?.tripFlightInfo?.rule_id,
        o?.tripFlightInfo?.ruleId,
        o?.product_info?.refund_term,
        o?.product_info?.refund_terms,
        o?.product_info?.refundTerm,
        o?.product_info?.refundTerms,
        o?.product_info?.rule_id,
        o?.product_info?.ruleId,
        o?.refund_term,
        o?.refund_terms,
        o?.refundTerm,
        o?.refundTerms,
        o?.rule_id,
        o?.ruleId,
        o?.membership_refund_rule_applied,
        o?.membershipRefundRuleApplied,
      ]
    },
    isMembershipRefundSourceEnabled(source) {
      if (source == null) return false
      if (typeof source === 'number') return source > 0
      if (typeof source === 'string') {
        const text = source.trim()
        if (!text) return false
        if (/^-?\d+(\.\d+)?$/.test(text)) return Number(text) > 0
        if (text === '[]' || text === '{}') return false
        return true
      }
      if (Array.isArray(source)) return source.some((item) => this.isMembershipRefundSourceEnabled(item))
      if (typeof source === 'object') {
        const values = Object.values(source)
        if (values.length === 0) return false
        return values.some((item) => this.isMembershipRefundSourceEnabled(item))
      }
      return false
    },
    hasMembershipRefundTerm() {
      return this.getMembershipRefundCandidates().some((source) => this.isMembershipRefundSourceEnabled(source))
    },
    hasAirDepositTerm() {
      const list = Array.isArray(this.terms) ? this.terms : []
      return list.some((line) => /your\s+(?:non-refundable|refundable)\s+air deposit is/i.test(String(line ?? '')))
    },
    shouldApplyMembershipRefundWording() {
      const memberType = this.resolveMemberType()
      const candidates = this.getMembershipRefundCandidates()
      const hasMembershipRule = candidates.some((source) => this.isMembershipRefundSourceEnabled(source))
      const hasAnnouncement = this.hasAirDepositTerm()
      return memberType > 0 && hasMembershipRule && hasAnnouncement
    },
    async airfareEvent() { 
      this.odata = await localDriver.getItem(this.odkey)     
      let info = {
        ispackage: this.odata.product_info.model.toUpperCase().slice(0, 3) == 'FP-' ? 1 : 0,
        finalprice: (parseFloat(this.odata.cityprice) + parseFloat(notEmpty(this.odata.flightOffer)?this.odata.flightOffer.price:this.flyOffer.price))
      }
      let pd = { offer_id: this.offerSelected, rid: this.respond_id,info:info }
      let rmlist = await localDriver.getItem(this.rmkey)
      this.persons = 0;
      for (let i in rmlist) {
        this.persons += (parseInt(rmlist[i].Adults) + parseInt(rmlist[i].Child));
      }
      this.flight_deposit = parseFloat((notEmpty(this.odata.flightOffer) && notEmpty(this.odata.flightOffer.deposit)
        && this.odata.flightOffer.deposit > 0) ? this.odata.flightOffer.deposit : this.odata.flights_amount);

      new Request().webPost(
        pd,
        (res) => {
          //console.log('------getFares---summary--', [pd, res]);
          if (res.success) {
            this.terms = res.data.terms;
          }
          this.airfaretips = true;
        },
        'product/flight/getFares'
      );

    },
    notEmpty(obj) {
      return notEmpty(obj);
    },
    flyWeekMDate(d, y = 1) {
      var dt = new Date((notEmpty(d) ? d.slice(0, 10) : d) + 'T00:00:01');
      var weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var formattedDate = weeks[dt.getDay()] + ", " + months[dt.getMonth()] + " " + dt.getDate() + ',' + (y > 0 ? ' ' + dt
        .getFullYear() : '');
      return formattedDate;
    },
    onlyFtime(d) {
      var dtstr = new Date(d).getFullstring(2);
      return dtstr.slice(11, 16);
    },
  }
};
</script>

<style scoped>
.pop_con {
  margin-top: 3rem; 
  overflow-y: auto;
}

.totalbox {
  padding: 0 2.4rem;
  border-radius: 1.2rem;
  margin-bottom: 2.4rem;
  background: #fff;
}

.totalbox .titbox {
  padding-top: 2rem;
  color: #333;
  font-family: Poppins-Bold;
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 2.2rem;
}

.totalbox .infobox {
  padding: 1.6rem 0 2.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #EAEAEA
}

.totalbox .infobox .pic {
  width: 8rem;
  height: 7rem;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.8rem;
}

.totalbox .infobox .txt {
  width: calc(100% - 9.2rem);
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2.0rem;
  text-align: left;
}

.totalbox .listbox {
  padding: 1.2rem 0;
  border-bottom: 1px solid #EAEAEA
}

.totalbox .listbox:last-child {
  border-bottom: 0;
}

.totalbox .listbox.ticket-price-box {
  border-bottom: 0;
}

.totalbox .listbox.flight-policy-box {
  border-top: 1px solid #EAEAEA;
}

.totalbox .listbox .tit {
  font-family: Poppins-Bold;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 2rem;
  padding: 0.8rem 0;
}

.totalbox .listbox .row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 2rem;
  padding: 0.8rem 0;
}

.totalbox .listbox .row.total {
  font-size: 1.6rem;
  font-family: Poppins-Bold;
  font-weight: 700;
}

.totalbox .listbox .row .label {
  color: #666666;
}

.totalbox .listbox .row .airico {
  width: 2rem;
  display: block;
}

.totalbox .listbox .row.total .label,
.totalbox .listbox .row .label span.black,
.totalbox .listbox .row .contxt {
  color: #333333;
}

.totalbox .listbox .row .contxt.route-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.2rem;
}

.totalbox .listbox .row .contxt .route-title {
  color: #333333;
}

.totalbox .listbox .row .contxt .route-subtitle {
  color: #999999;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.8rem;
}

.totalbox .listbox .row .contxt.stop-summary {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.8rem;
  flex-wrap: wrap;
  text-align: right;
}

.overnight-warning {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #F04F4F;
  font-family: Poppins-Bold;
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.6rem;
}

.overnight-warning-icon {
  width: 1.6rem;
  height: 1.6rem;
  display: block;
}

.totalbox .listbox .row .green {
  color: #4F6F52 !important;
}

.totalbox .listbox .contxt span {
  color: #1B80DE;
  cursor: pointer;
}

.totalbox .listbox .row .contxt.stop-summary span {
  color: #333333;
  cursor: default;
}

.totalbox .listbox .row .contxt.stop-summary .overnight-warning {
  color: #F04F4F;
}

.totalbox .listbox .contxt .ico {
  width: 2rem;
  display: inline-block;

}

.totalbox .listbox .row .contxt div {
  text-align: right;
}

.prop .airfaretipscon {
  padding: 2.4rem;
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
  text-align: left;
  color: #333;
  max-width: 66rem;
}

.prop .airfaretipscon p {
  padding-left: 2.4rem;
  position: relative;
}

.prop .airfaretipscon p::before {
  content: '';
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: #333;
  position: absolute;
  top: 1rem;
  left: 1rem;
}

.click {
  font-size: 1.3rem !important;

}

.click span {

  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* 移动端  */
@media screen and (max-width:750px) {
  .prop {
    z-index: 999999;
  }

  .prop .con {
    position: absolute;
    box-sizing: border-box;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 2rem;
    box-shadow: 0px 10px 60px -10px #00000014;
    /* 保证上下各留5%空间 */
    overflow: auto;
    /* 内容溢出时出现滚动条 */
    width: 90% !important;
  }
  .prop .con .fixed_closer {

top: 0.0rem!important;

}
  
}
</style>
